import React from "react";

const ClientPropOne = ({ projectStyle, portfolio }) => {
  return (
    <>
      <div className={`client-grid ${projectStyle}`}>
        <div className="thumbnail2">
          <img src={process.env.PUBLIC_URL + portfolio.image} alt="icon" />
        </div>
      </div>
    </>
  );
};

export default ClientPropOne;
